<div
  id="DetailViewComponent"
  class="card esri-widget animated fadeIn"
  #detailViewComponentRef
  [class.view-expanded]="viewExpanded"
>
  <!--Panel Heading -->
  <detail-view-header [detailFormDataModel]="detailFormDataModel" (closeEvent)="close()"></detail-view-header>

  <!-- Card Body - Main Content -->
  <div class="card-body">
    <mat-accordion [multi]="true">
      <!--form section -->
      <accordion-form-section [title]="'COMMON.ATTRIBUTE'" [expanded]="true">
        <form *ngIf="graphicFormGroup" [formGroup]="graphicFormGroup" class="needs-validation" #detailViewFormRef>
          <!-- Provisorische Meldung in der Objektmaske ImmoGIS -->
          <denkmalpflege-message [isDenkmalpflege]="isDenkmalpflege"></denkmalpflege-message>
          <!-- form: attributes -->
          <form-builder
            [formattedFormFields]="formattedFormFields"
            [graphicFormGroup]="graphicFormGroup"
            [detailFormDataModel]="detailFormDataModel"
            [viewExpanded]="viewExpanded"
          >
          </form-builder>
        </form>

        <div>
          <part-features-table
            *ngIf="showPartFeatures && detailFormDataModel"
            [detailFormDataModel]="detailFormDataModel"
            [featureparams]="featureParams"
          >
          </part-features-table>
        </div>
      </accordion-form-section>
      <!-- relationship tables -->
      <accordion-form-section
        *ngFor="let relatedTableConfig of featureParams.relatedTableConfigs; let i = index"
        [title]="'DETAIL_VIEW.ACCORDION.HEADER.TITEL_NUTZUNGSSICHT'"
        [expanded]="false"
      >
        <related-table
          [detailViewExpanded]="viewExpanded"
          [relatedTabIndex]="i"
          [relatedTableConfig]="relatedTableConfig"
          [featureParams]="featureParams"
        >
        </related-table>
      </accordion-form-section>
    </mat-accordion>

  </div>

  <!--Card Footer-->
  <div class="card-footer">
    <div class="attributes-tab float-left" *ngIf="attributesTabActive === true">
      <!-- edit-mode buttons -->
      <div *ngIf="!featureParams.createMode">
        <!-- save -->
        <button
          *ngIf="allowEditFeature && featureIsEditable"
          [disabled]="!graphicFormGroup.dirty && !featureGeometryEdited"
          class="btn btn-sm btn-primary"
          (click)="onSave()"
          translate
        >
          <i class="material-icons md-18 md-btn-align">save</i>COMMON.SAVE
        </button>
        <!-- delete -->
        <button
          class="btn btn-sm btn-danger ml-1"
          *ngIf="allowDeleteFeature && featureIsEditable"
          (click)="onDelete()"
          translate
        >
          <i class="material-icons md-18 md-btn-align">delete_forever</i>COMMON.DELETE
        </button>
        <!-- start edit geometry -->
        <button
          class="btn btn-sm btn-warning ml-1"
          *ngIf="allowEditFeature && featureIsEditable"
          (click)="activateEditTool()"
          translate
        >
          <i class="material-icons md-18 md-btn-align">border_color</i>COMMON.STARTEDITGEOMETRY
        </button>
        <!-- close -->
        <button class="btn btn-sm btn-light ml-1" (click)="close()" translate>
          <i class="material-icons md-18 md-btn-align">close</i>COMMON.CLOSE
        </button>
        <!-- send sap id  -->
        <button
          class="btn btn-sm btn-light ml-1"
          [disabled]="disabledSend"
          *ngIf="allowDeleteFeature && featureIsEditable"
          (click)="sendSapId($event)"
          translate
        >
          <i class="material-icons md-18 md-btn-align">send</i>DETAIL_VIEW.SEND_SAP_ID
        </button>
      </div>

      <!-- create-mode buttons -->
      <div *ngIf="featureParams.createMode">
        <!-- check sap id  -->
        <button class="btn btn-sm btn-warning ml-1" (click)="checkSapId($event)" translate>
          <i class="material-icons md-18 md-btn-align">check</i>DETAIL_VIEW.CHECK_SAP_ID
        </button>
        <!-- create -->
        <button class="btn btn-sm btn-primary ml-1" (click)="onSave($event)" translate>
          <i class="material-icons md-18 md-btn-align">create</i>COMMON.CREATE
        </button>
        <!-- cancel -->
        <button class="btn btn-sm btn-light ml-1" (click)="cancel()" translate>
          <i class="material-icons md-18 md-btn-align">close</i>COMMON.CANCEL
        </button>
      </div>
    </div>
    <div class="attributes-tab float-left" *ngIf="attributesTabActive === false">
      <!-- close -->
      <button class="btn btn-sm btn-light ml-1" (click)="close()" translate>
        <i class="material-icons md-18 md-btn-align">close</i>COMMON.CLOSE
      </button>
    </div>
  </div>
</div>
